import styled from 'styled-components';

export const MisSummaryCard = styled.div`
position:static;
width:85%;
margin-top: 24px;
height: 140px;
display:flex;
flex-direction:column;
align-items:center;
justify-content:space-between;

`;

export const SummaryBox = styled.div`
position:static;
width:100%;
height:66px;
display:flex;
flex-direction:row;
justify-content:space-between;
align-items:center;
`;

export const SummaryCardBig = styled.div`
position:static;
width:48%;
height:66px;
border:1px solid black;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background: #F9F9F9;
border: 1px solid #F5F5F5;
border-radius: 4px;
`;

export const SummaryCardSmall = styled(SummaryCardBig)`
width:32%
`;

export const CardText = styled.span`
font-family: Nunito;
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 18px;
color: #1E1E1E;
`;

export const MisChildCardSummaryValue = styled(CardText)`
line-height:140%;
font-weight:600;
font-size:16px;
color:#454ADE;
`;

export const CardLabel = styled.span<{ backgroundColor: string }>`
position:static;
margin-top:2%;
height:16px;
box-sizing:border-box;
background: ${props=>props.color};
border-radius: 2px;
padding:0% 5%;
display:flex;
align-items:center;
justify-content:center;
border-left: 2px solid ${props=>props.backgroundColor};
`;

export const CardLabelText = styled.span`
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 10px;
line-height: 12px;
text-align: center;
text-transform: uppercase;
white-space:nowrap;
color:${props=>props.color};
`;

export const MisCardLine = styled.div`
position:static;
width:100%;
height: 1px;
margin-top:24px;
background: #EBEBEC;
border-radius: 1px;
`;

export const CardsHeader = styled.span`
position: static;
height: 20px;
width:90%;
margin-left:5%;
margin-top:24px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 140%;
display: flex;
text-align:flex-start;
justify-content:flex-start;
color: #6D6D6D;
`;

export const MisCardsListDiv = styled.div`
poistion:static;
width:90%;
margin-top:12px;
display:flex;
flex-direction:column;
`;

export const MisChildCard = styled.div`
poistion:static;
height:118px;
margin-bottom:16px;
display:flex;
flex-direction:column;
justify-content:flex-start;
align-items:center;
background: #FFFFFF;
border: 1px solid #EBEBEC;
border-radius: 12px;
`;

export const MisChildHeaderDiv = styled.div`
position:static;
width:100%;
padding:3% 0% 3% 3%;
box-sizing:border-box;
height:50px;
display:flex;
flex direction:row;
justify-content:space-between;
align-items:center;
background: #F9F9F9;
border-radius: 12px;
`;

export const MisChildSummaryDiv = styled.div`
position:static;
width:95%;
padding-left:2.5%;
padding-right:2.5%;
box-sizing:border-box;
height:39px;
margin-top:12px;
display:flex;
flex-direction:row;
justify-content:space-between;
`;

export const MisChildCardSummaryBox = styled.div`
position:static;
height:39px;
display:flex;
flex-direction:column;
justify-content:space-between;
align-items:center;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 140%;
`;

export const MISChildCardBranchText = styled.span`
position:static;
width:100%;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 120%;
display: flex;
align-items: center;
color: #000000;
`;

export const MISChildCardGstinText = styled.span`
position:static;
width:100%;
margin-top:4px;
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 11px;
line-height: 140%;
display: flex;
align-items: center;
color: #6D6D6D;
`;
